<div style="width: 100%;">
    <app-asset-group *ngIf="loggingGroup === 'asset'"></app-asset-group>
    <app-core-group *ngIf="loggingGroup === 'core'"></app-core-group>
    <app-user-group *ngIf="loggingGroup === 'user'"></app-user-group>
</div>

<div *ngIf="loggingGroup === null">
    <p>Please select a logging group above!</p>
  </div>